import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  getAccessToken,
  isAdminPortalUser,
  removeAccessToken,
  removeUserInfoFromStorage,
  setAccessToken,
  setUserInfoInStorage,
  useQuery,
} from 'utils/common'
import AuthScreen from 'components/sign-in/AuthScreen'
import ForgotPasswordForm from 'components/sign-in/ForgotForm'
import SignInForm from 'components/sign-in/SignInForm'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import { alertTypes } from 'constants/Common'
import { getAuthToken } from './Api'

const ADMIN_PORTAL_ACCESS_MESSAGE = 'Only admins have access to the portal.'

const isAdminUser = (user) => isAdminPortalUser(user)

const getLoginErrorMessage = (error) => {
  const apiError = error?.response?.data?.error

  if (typeof apiError === 'string') {
    const normalized = apiError.trim().toLowerCase()
    if (
      normalized.includes('not authorized to login to panel') ||
      normalized.includes('only admins have access to the portal') ||
      normalized.includes('organizationid header is required')
    ) {
      return ADMIN_PORTAL_ACCESS_MESSAGE
    }
    return apiError
  }

  return 'Error'
}

function SignIn() {
  const query = useQuery()
  const navigate = useNavigate()
  const shouldResetPassword = query.get('reset')
  const eventsAttended = query.get('eventsattended')
  const loginFormSubmitHandler = async (values, setSubmitting) => {
    setSubmitting(true)
    try {
      const response = await getAuthToken(values)

      if (response.status === 200) {
        if (!isAdminUser(response.User)) {
          removeAccessToken()
          removeUserInfoFromStorage()
          toast(
            <CustomToast
              variant={alertTypes.DANGER}
              message={ADMIN_PORTAL_ACCESS_MESSAGE}
            />
          )
          return
        }

        toast(
          <CustomToast
            variant={alertTypes.SUCCESS}
            message={response?.statusText || 'SignIn Successfully!'}
          />
        )

        setAccessToken(response.User.token)
        setUserInfoInStorage(response.User)
        setTimeout(() => {
          // navigate('/users')
          window.location.reload()
        }, 2000)
      }
    } catch (error) {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={getLoginErrorMessage(error)}
        />
      )
      console.log(error)
    }
    setSubmitting(false)
  }
  useEffect(() => {
    if (getAccessToken()) {
      if (eventsAttended) {
        navigate(`/eventsattended/${eventsAttended}`)
      } else navigate('/select-event')
    }
  }, [])
  return (
    <AuthScreen>
      {shouldResetPassword ? (
        <ForgotPasswordForm />
      ) : (
        <SignInForm loginFormSubmitHandler={loginFormSubmitHandler} />
      )}
    </AuthScreen>
  )
}
export default SignIn
